import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map, Observable, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ErrorHandlingService } from './error-handling.service';
import languageConfigData from '../../../assets/data/language-config.json';
import { CallFlagService } from '../learner/call-flag/call-flag.service';
import { ActivatedRoute } from '@angular/router';
import { Language } from '../../interfaces/ilanguage';
@Injectable({
  providedIn: 'root',
})
export class GenderService {
  readonly validGenders = ['male', 'female'];
  private readonly languageConfig: Language[] = languageConfigData.languages;
  backendUrl: string = environment.backendUrl;

  constructor(
    private http: HttpClient,
    private errorHandlingService: ErrorHandlingService,
    private callFlagService: CallFlagService,
    private route: ActivatedRoute
  ) {}

  getUserGender(): string | null {
    const gender = localStorage.getItem('user_gender');
    if (!gender || gender === 'null' || gender === '') {
      return null;
    }
    return gender;
  }

  isGenderInputRequired(): boolean {
    const gender = this.getUserGender();
    return !gender || !this.validGenders.includes(gender);
  }

  saveUserGender(userUuid: string, gender: string): Observable<void> {
    if (!gender || gender === 'null' || gender === '') {
      throw new Error('Cannot update user gender: gender is null or empty');
    }
    const payload = { userUuid, userGender: gender.toLocaleUpperCase() };
    return this.http
      .post(`${this.backendUrl}/user/updateUserGender`, payload, {
        responseType: 'text' as 'json',
      })
      .pipe(
        map((result) => result),
        tap((res: Object) => {
          const outcome = res ? 'fetched' : 'did not find';
          console.log(`update user gender: ${outcome}`);
        }),
        catchError((error) => {
          return this.errorHandlingService.handleError<any>(
            `/user/updateUserGender`
          )(error);
        })
      );
  }

  isGenderRequiredForCurrentLanguage(): boolean {
    const callUuid = this.route.snapshot.queryParamMap.get('callUuid') || '';
    const flags = this.callFlagService.getCallFlagsLS(callUuid);
    const callLanguage = flags?.language;
    console.log('callLanguage: ', callLanguage);
    // SAFE: internal language-code identifiers, not free-form text
    const config = this.languageConfig.find(
      (lang) => lang?.code?.toLowerCase() === callLanguage?.toLowerCase()
    );
    return config?.requiresGender || false;
  }
}
